// extracted by mini-css-extract-plugin
module.exports = {"container":"Product_container__DX_AY","title":"Product_title__Dmfly","separator":"Product_separator__w_NSx","image-container":"Product_image-container__HCw4q"};